import React, { useState, useContext, useRef } from "react"
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import errorMessages, { generalErrorMessage } from "../config/errorMessages"
import errorMessagesBM, { generalErrorMessageBM } from "../config/errorMessagesBM"
// import { useForm } from "react-hook-form";
import axios from "axios";
import { AppContext } from "../contexts"
import Select from "react-select"
import options from "../config/occupation"

const ErrorDialog = ({ isOpen, toggle, message, responseData, type, lang }) => {
	const state = useContext(AppContext)
	//const getErrorMessage = errorMessages.find((errorMessage) => errorMessage.apiError === message)?.message
	const getErrorMessage = lang.id === 'EN' ? errorMessages.find((errorMessage) => errorMessage.apiError === message)?.message : errorMessagesBM.find((errorMessage) => errorMessage.apiError === message)?.message

	const displayGeneralErrorMsg = lang.id === 'EN' ? generalErrorMessage : generalErrorMessageBM

	const [correspondenceAddress, setCorrespondenceAddress] = useState(false)
	const [contactNumber, setContactNumber] = useState()
	const [occupation, setOccupation] = useState(false)

	let codeHtml = "";

	const isLeadGenForm = message !== undefined && typeof message === "string" &&
		(
			// (message.indexOf("We are unable to renew your car insurance online due to your insurance policy has lapsed for more than") > -1) ||
			// (message.indexOf('There was an error in retrieving your') > -1) ||
			(message.indexOf("Lapsed") > -1) //||
			// (message.indexOf("SUM INSURED IS 0") > -1) ||
			// (message.indexOf("UW Policy holder Age Referred") > -1)
		);

	const customStyles = {
		option: (provided, state) => ({
			...provided,
			padding: 10,
			lineHeight: 1.2,
			color: state.isSelected ? 'white' : '#5F5456',
			backgroundColor: state.isSelected ? '#CC0022' : 'white'
		}),
		control: (provided, state) => {
			// none of react-select's styles are passed to <Control />
			const cstyle = {
				paddingTop: 12,
				border: 'none',
				paddingLeft: 5
			}
			return { ...provided, ...cstyle };
		},
		singleValue: (provided, state) => {
			const opacity = state.isDisabled ? 0.5 : 1;
			const transition = 'opacity 300ms';

			return { ...provided, opacity, transition };
		}
	}

	const Results = () => (
		<div className="mt-3 mb-3 text-left">
			{/* <font color='black'>{lang.form.msg5}</font> */}
			<font color='black'>{lang.errors.msg}</font>
		</div>
	)

	let btnRef = useRef()

	const normalizeAddress = (e) => {
		state.setCorAddress(false)
		const { value } = e.target
		setCorrespondenceAddress(value)
	}

	const normalizeContact = (e) => {
		state.setContactNo(false)
		let value = e.target.value
		value = value.replace(/[^0-9]+/g, "")
		setContactNumber(value)
	}

	const handleOccupation = selectedOccupation => {
		state.setOccp(false)
		setOccupation(selectedOccupation.label)
	}

	const CorrErrMsg = () => (
		// <font color='red'>{lang.form.errorRequired}</font>
		<font color='red'>This field is required"</font>
	)

	if (isLeadGenForm) {
		//type=P, B.
		if (type === 'P') {
			codeHtml =
				<div className="row">
					<div className="col-12 mb-3 text-center">
						{/* {lang.errors.msg4_2} */}
						To request a quotation manually, please fill in the details below.
					</div>
					<div className="col-md-6 mb-2">
						<div className="floating">
							<input
								type="text"
								name="registrationNo"
								// placeholder={lang.vehPlateNo}
								placeholder="Vehicle Plate Number"
								className="floating__input disable"
								readOnly={true}
								value={responseData.registrationNo}
								maxLength={15}
							/>
							{/* <label htmlFor="input__username" className="floating__label" data-content={lang.form.vehRegNo} /> */}
							<label htmlFor="input__username" className="floating__label" data-content={lang.errors.vehicleRegistrationNo} />
						</div>
					</div>
					<div className="col-md-6 mb-2">
						<div className="floating">
							<input
								className="floating__input disable"
								type="text"
								name="nricPassport"
								// placeholder={lang.nricPassport}
								placeholder="NRIC No./Passport"
								maxLength={14}
								readOnly={true}
								value={responseData.nricPassport}
							/>
							{/* <label htmlFor="input__username" className="floating__label" data-content={lang.nricPassport} /> */}
							<label htmlFor="input__username" className="floating__label" data-content={lang.errors.nricPassport} />
						</div>
					</div>
					<div className="col-md-6 mb-2">
						<div className="floating">
							<input
								className="floating__input disable"
								type="text"
								name="email"
								// placeholder={lang.email}
								placeholder="Email"
								maxLength={60}
								readOnly={true}
								value={responseData.email}
							/>
							{/* <label htmlFor="input__username" className="floating__label" data-content={lang.email} /> */}
							<label htmlFor="input__username" className="floating__label" data-content={lang.errors.email} />
						</div>
					</div>
					<div className="col-md-6 mb-2">
						<div className="floating">
							<input
								className="floating__input disable"
								type="text"
								name="name"
								maxLength={60}
								// placeholder={lang.shortFullName}
								placeholder="Full Name"
								readOnly={true}
								value={responseData.name}
							/>
							{/* <label htmlFor="input__username" className="floating__label" data-content={lang.form.fullName} /> */}
							<label htmlFor="input__username" className="floating__label" data-content={lang.errors.fullName} />
						</div>
					</div>
					<div className="col-md-12 mb-2">
						<div className="floating">
							<input
								className="floating__input"
								type="text"
								name="Correspondence_Address"
								// placeholder={lang.address}
								placeholder="Address"
								maxLength={180}
								onChange={(e) => normalizeAddress(e)}
							/>
							{/* <label htmlFor="input__username" className="floating__label" data-content={lang.CorrAddress} /> */}
							<label htmlFor="input__username" className="floating__label" data-content={lang.errors.CorrAddress} />
						</div>
						{state.corAddress ? <CorrErrMsg /> : null}
					</div>
					<div className="col-md-6 mb-2">
						<div className="floating">
							<input
								className="floating__input"
								type="tel"
								name="Contact_Number"
								value={contactNumber}
								// placeholder={lang.contactNo}
								placeholder="Contact Number"
								maxLength={20}
								onChange={(e) => normalizeContact(e)}
							/>
							{/* <label htmlFor="input__username" className="floating__label" data-content={lang.contactNo} /> */}
							<label htmlFor="input__username" className="floating__label" data-content={lang.errors.contactNo} />
						</div>
						{state.contactNo ? <CorrErrMsg /> : null}
					</div>
					<div className="col-md-6 mb-2">
						<div className="select">
							<div className="floating">
								<Select className="floating__input3" value={options.find(obj => obj.value === occupation)}
									onChange={handleOccupation}
									options={options}
									// placeholder={lang.form.pleaseSelect}
									placeholder={lang.selection}
									styles={customStyles}
								/>
								{/* <label className="floating-label">{lang.form.occupation}</label> */}
								<label className="floating-label">{lang.errors.occupation}</label>
								<input type="hidden" name="occupation*" />
							</div>
						</div>
						{state.occp ? <CorrErrMsg /> : null}
					</div>
					<div className={`col-md-4 offset-md-4`}>
						<div className="button-box mt-3 mb-3">
							<button type="submit" ref={btnRef} onClick={(e) => onSubmitClick(e)} className="btn btn-sompo_primary red ">Submit</button>
						</div>
					</div>
				</div>
		} else if (type === 'B') {
			codeHtml =
				<div className="row">
					<div className="col-12 mb-1">
						{/* {lang.errors.msg4_2}	 */}
						To request a quotation manually, please fill in the details below.
					</div>
					<div className="col-md-6 mb-2">
						<div className="floating">
							<input
								type="text"
								name="registrationNo"
								//placeholder={lang.vehPlateNo}
								placeholder="Vehicle Plate Number"
								className="floating__input disable"
								readOnly={true}
								value={responseData.registrationNo}
								maxLength={15}
							/>
							{/* <label htmlFor="input__username" className="floating__label" data-content={lang.form.vehRegNo}/> */}
							<label htmlFor="input__username" className="floating__label" data-content="Vehicle Registration No." />
						</div>
					</div>
					<div className="col-md-6 mb-2">
						<div className="floating">
							<input
								className="floating__input disable"
								type="text"
								name="bizRegNo"
								// placeholder={lang.form.busRegNo}
								placeholder="Business Registration No."
								maxLength={20}
								readOnly={true}
								value={responseData.bizRegNo}
							/>
							{/* <label htmlFor="input__username" className="floating__label" data-content={lang.form.busRegNo} /> */}
							<label htmlFor="input__username" className="floating__label" data-content="Business Registration No." />
						</div>
					</div>
					<div className="col-md-6 mb-2">
						<div className="floating">
							<input
								className="floating__input disable"
								type="text"
								name="email"
								//placeholder={lang.email}
								placeholder="Email"
								maxLength={60}
								readOnly={true}
								value={responseData.email}
							/>
							{/* <label htmlFor="input__username" className="floating__label" data-content={lang.email} /> */}
							<label htmlFor="input__username" className="floating__label" data-content="Email" />
						</div>
					</div>
					<div className="col-md-6 mb-2">
						<div className="floating">
							<input
								className="floating__input disable"
								type="text"
								name="name"
								maxLength={60}
								// placeholder={lang.companyName}
								placeholder="Company Name"
								readOnly={true}
								value={responseData.name}
							/>
							{/* <label htmlFor="input__username" className="floating__label" data-content={lang.companyName} /> */}
							<label htmlFor="input__username" className="floating__label" data-content="Company Name*" />
						</div>
					</div>
					<div className="col-md-12 mb-2">
						<div className="floating">
							<input
								className="floating__input"
								type="text"
								name="Correspondence_Address"
								// placeholder={lang.address}
								placeholder="Address"
								maxLength={180}
								onChange={(e) => normalizeAddress(e)}
							/>
							{/* <label htmlFor="input__username" className="floating__label" data-content={lang.corrAddress}/> */}
							<label htmlFor="input__username" className="floating__label" data-content="Correspondence Address*" />
						</div>
						{state.corAddress ? <CorrErrMsg /> : null}
					</div>
					<div className="col-md-6 mb-2">
						<div className="floating">
							<input
								className="floating__input"
								type="tel"
								name="Contact_Number"
								//placeholder={lang.contactNo}
								placeholder="Contact Number"
								value={contactNumber}
								maxLength={20}
								onChange={(e) => normalizeContact(e)}
							/>
							{/* <label htmlFor="input__username" className="floating__label" data-content={lang.contactNo} /> */}
							<label htmlFor="input__username" className="floating__label" data-content="Contact Number*" />
						</div>
						{state.contactNo ? <CorrErrMsg /> : null}
					</div>
					<div className="col-md-6 mb-2">
						<div className="select">
							<div className="floating">
								<Select className="floating__input3" value={options.find(obj => obj.value === occupation)}
									onChange={handleOccupation}
									options={options}
									// placeholder={lang.form.pleaseSelect}
									placeholder="Please Select"
									styles={customStyles}
								/>
								{/* <label className="floating-label">{lang.form.typeOfBusiness}</label> */}
								<label className="floating-label">"Type of Business"</label>
								<input type="hidden" name="occupation" />
							</div>
						</div>
						{state.occp ? <CorrErrMsg /> : null}
					</div>
					<div className={`col-md-4 offset-md-4`}>
						<div className="button-box mt-3 mb-3">
							{/* <button type="submit" ref={btnRef} onClick={(e)=> onSubmitClick(e)} className="btn btn-sompo_primary red">{lang.submit}</button> */}
							<button type="submit" ref={btnRef} onClick={(e) => onSubmitClick(e)} className="btn btn-sompo_primary red">Submit</button>
						</div>
					</div>
				</div>
		}
	}

	const onSubmitClick = (e) => {

		if (!correspondenceAddress || correspondenceAddress === undefined || correspondenceAddress === '') {
			state.setCorAddress(true)
			return
		}
		if (!contactNumber || contactNumber === undefined || contactNumber === '') {
			state.setContactNo(true)
			return
		}
		if (!occupation || occupation === undefined || occupation === '') {
			state.setOccp(true)
			return
		}

		let html = '';
		if (type === 'P') {
			// html = `<html>errorMessage from user: ` + responseData.fullErrorMsg + ` <br/>`
			html = `<html>errorMessage from user: ` + message + ` </br>`
			html = html + `TYPE: ` + type + `</br>`
			html = html + `email address: ` + responseData.email + `</br>`
			html = html + `registrationNo: ` + responseData.registrationNo + `</br>`
			html = html + `nricPassport: ` + responseData.nricPassport + `</br>`
			html = html + `name: ` + responseData.name + `</br>`
			html = html + `correspondenceAddress: ` + correspondenceAddress + `</br>`
			html = html + `contactNumber: ` + contactNumber + `</br>`
			html = html + `occupation: ` + occupation + `</br></html>`
		} else if (type === 'B') {
			// html = `<html>errorMessage from user: ` + responseData.fullErrorMsg + ` <br/>`
			html = `<html>errorMessage from user: ` + message + ` </br>`
			html = html + `TYPE: ` + type + `</br>`
			html = html + `email address: ` + responseData.email + `</br>`
			html = html + `registrationNo: ` + responseData.registrationNo + `</br>`
			html = html + `bizRegNo: ` + responseData.bizRegNo + `</br>`
			html = html + `Company name: ` + responseData.name + `</br>`
			html = html + `correspondenceAddress: ` + correspondenceAddress + `</br>`
			html = html + `contactNumber: ` + contactNumber + `</br>`
			html = html + `Type of Business: ` + occupation + `</br></html>`
		}

		axios.post('/email/sendmail/', {
			email: 'banca.support@bsompo.com.my',
			//email: 'thyong@bsompo.com.my',
			subject: 'CIMB Secure Motor Staff: Car Insurance Quotation',
			content: html
		}).then(function (response) {
			// console.log('### errorDia')
			// console.dir(response)
			if (response.data === 'OK' || response.data == 'OK') {
				state.setShowResults(true)
				if (btnRef.current) {
					btnRef.current.setAttribute("disabled", "disabled");
				}
			} else if (response === 'OK') {
				state.setShowResults(true)
				if (btnRef.current) {
					btnRef.current.setAttribute("disabled", "disabled");
				}
			}
		}).catch(function (error) { })
	}

	return <>
		{isLeadGenForm ?
			<Modal isOpen={isOpen} toggle={toggle} className="contact">
				<ModalHeader toggle={toggle}>{lang.errors.errorOccured}!</ModalHeader>
				<ModalBody>
					<div className="col-md-12 text-center">
						{getErrorMessage || displayGeneralErrorMsg}
					</div>
					<div className="col-md-12">

						{codeHtml}
						{state.showResults ? <Results /> : null}
					</div>
				</ModalBody>
				{/* <ModalFooter>
      <Button onClick={() => toggle()}>Ok</Button>
    </ModalFooter> */}
			</Modal>
			:
			<Modal isOpen={isOpen} toggle={toggle} className="contact">
				<ModalHeader toggle={toggle}>{lang.errors.errorOccured}</ModalHeader>
				<ModalBody>
					{getErrorMessage || displayGeneralErrorMsg}
				</ModalBody>
				<ModalFooter>
					<Button onClick={() => toggle()}>Ok</Button>
				</ModalFooter>
			</Modal>
		}
	</>
}

export default ErrorDialog